/** 印度 MGM 生产已开通；设为 false 可临时屏蔽前端 INR 入口。 */
export const TOPPAY_INDIA_FRONTEND_ENABLED = true;

/** TopPay region ↔ fiat currency mapping (backend models.TopPayRegion*). */
export const TOPPAY_FIAT_CURRENCIES = Object.freeze(['VND', 'BRL', 'MXN', 'INR']);

export const TOPPAY_CURRENCY_TO_REGION = Object.freeze({
  VND: 'VN',
  BRL: 'BR',
  MXN: 'MX',
  INR: 'IN',
});

export const TOPPAY_REGION_TO_CURRENCY = Object.freeze({
  VN: 'VND',
  BR: 'BRL',
  MX: 'MXN',
  IN: 'INR',
});

export function currencyToTopPayRegion(currency) {
  const code = String(currency ?? '')
    .trim()
    .toUpperCase();
  return TOPPAY_CURRENCY_TO_REGION[code] || '';
}

export function isTopPayFiatCurrency(currency) {
  const code = String(currency ?? '')
    .trim()
    .toUpperCase();
  if (!TOPPAY_INDIA_FRONTEND_ENABLED && code === 'INR') return false;
  return TOPPAY_FIAT_CURRENCIES.includes(code);
}

/** Force-disable IN region after API parse when frontend gate is off. */
export function stripIndiaFromTopPayRegions(regions) {
  if (TOPPAY_INDIA_FRONTEND_ENABLED || !regions || typeof regions !== 'object') {
    return regions;
  }
  const next = { ...regions };
  if (next.IN) {
    next.IN = { ...next.IN, enabled: false, methods: [] };
  }
  return next;
}

/** Remove INR rows from cash fiat picker (Alchemy + TopPay merge). */
export function filterIndiaFiatCurrencyRows(rows) {
  if (TOPPAY_INDIA_FRONTEND_ENABLED) return rows;
  return (Array.isArray(rows) ? rows : []).filter(
    (row) =>
      String(row?.currency ?? '')
        .trim()
        .toUpperCase() !== 'INR'
  );
}

export function topPayAmountDecimals(regionOrCurrency) {
  const raw = String(regionOrCurrency ?? '').trim().toUpperCase();
  if (raw === 'VN' || raw === 'VND') return 0;
  if (
    raw === 'BR' ||
    raw === 'BRL' ||
    raw === 'MX' ||
    raw === 'MXN' ||
    raw === 'IN' ||
    raw === 'INR'
  ) {
    return 2;
  }
  return 2;
}
